import api from "../api";


export const updateMessageTitleGat = async (userId: string, messageTitle: string, newEmailBody?: string): Promise<boolean> => {
  const result = await api.put(`/settings`, {userId, messageTitle, EmailBody: newEmailBody});
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getMessageTitleByUserIdGat = async (userId: string): Promise<any> => {
  const result = await api.get(`/settings?userId=${userId}`);
  if (result.status === 200) {
    return result.data;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};
